import { render } from "./BuyParalleliums.vue?vue&type=template&id=262eeb94&scoped=true"
import script from "./BuyParalleliums.vue?vue&type=script&lang=js"
export * from "./BuyParalleliums.vue?vue&type=script&lang=js"

import "./BuyParalleliums.vue?vue&type=style&index=0&id=262eeb94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262eeb94"]])

export default __exports__